import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Checkbox from 'aquilla/core/atoms/Checkbox';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
  font-size: ${Fonts.H6};
  flex-wrap: wrap;
  ${mediaQuery.uptoMobile} {
    gap: 28px;
  }
`;
const MultiCheckBox = ({ onChange, referralFeedbackData, feedBackData }) => {
  const isChecked = (value) => feedBackData?.includes(value);

  return (
    <>
      <Container>
        {referralFeedbackData.map((option) => (
          <div key={option.index}>
            <Checkbox
              isChecked={isChecked(option)}
              onChange={() => onChange(option)}
            >
              {option}
            </Checkbox>
          </div>
        ))}
      </Container>
    </>
  );
};
export default MultiCheckBox;
